import { render, staticRenderFns } from "./NewsDetailThree.vue?vue&type=template&id=63a8eba3&scoped=true&"
import script from "./NewsDetailThree.vue?vue&type=script&lang=js&"
export * from "./NewsDetailThree.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailThree.vue?vue&type=style&index=0&id=63a8eba3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8eba3",
  null
  
)

export default component.exports